import type { GlobalTranslations } from "../interfaces/global";

export const globalTranslations: GlobalTranslations = {
  two_factor_required_generic: "Enable two-factor authentication to continue",
  two_factor_required_modal_title: "Two-factor authentication required",
  two_factor_required_modal_cancel: "Cancel",
  two_factor_required_modal_go_to_settings: "Go to settings",
  two_factor_challenge_title: "Verify your identity",
  two_factor_challenge_description: "Enter the 6-digit code from your authenticator app to continue.",
  two_factor_challenge_submit: "Verify",
  two_factor_challenge_error_invalid_code: "Incorrect code. Try again.",
  input_error_invalid_email: "Enter a valid email address.",
  input_error_required: "This field is required",
  input_error_min_length: "This field must be at least {{length}} characters",
  input_error_max_length: "This field must be at most {{length}} characters",
  input_error_min_items: "Must have at least {{items}} items",
  input_error_max_items: "Must have at most {{items}} items",
  input_error_min_value: "Must be greater than or equal to {{min}}",
  input_error_max_value: "Must be less than or equal to {{max}}",
  input_error_too_small: "The minimum is {{min}}",
  input_error_too_big: "The maximum is {{max}}",
  input_error_invalid_url: "Enter a valid URL",
  input_error_invalid_uuid: "Invalid identifier",
  input_error_invalid_format: "The format is not valid",
  input_error_invalid_value: "The value is not valid",
  logout: "Log out",
  input_error_phone_indicative_required: "The indicative is required",
  input_error_phone_required: "The phone number is required",
  input_error_phone_invalid: "The phone number format is invalid for the selected country",
  input_error_register_code:
    "The format must be xxxxxxxxxxxxxx== where x can be letters, numbers, and symbols.",
  input_error_not_terms: "You must accept our terms and conditions",
  error_login_credentials: "Check your username or password.",
  successful_deletion_message: "Successfully deleted.",
  successful_disabled_message: "Successfully disabled.",
  successful_active_message: "Successfully activated.",
  successful_create_message: "Successfully created.",
  successful_update_message: "Successfully updated.",
  error_token_message:
    "An error occurred due to the non-existence or prior use of the token. Please generate a new token to continue.",
  input_optional_label: "(optional)",
  input_show_password_label: "Show password",
  input_hide_password_label: "Hide password",
  input_search_placeholder: "Search",
  input_phone_number_placeholder: "Enter your phone number",
  input_phone_number_label: "Phone number",
  not_found_message: "No results found",
  input_phone_label: "Phone",
  input_phone_placeholder: "Enter the phone number",
  input_date_placeholder: "Pick a date",
  sidebar_settings_label: "Settings",
  sidebar_section_billeteras: "Wallets",
  sidebar_section_operaciones: "Operations",
  sidebar_section_analitica: "Analytics",
  sidebar_section_gestion: "Management",
  sidebar_section_tarjetas: "Cards",
  sidebar_menu_wallets_home: "Wallets",
  sidebar_menu_wallets: "Wallets",
  sidebar_menu_payouts: "Send money",
  sidebar_menu_breb_qr_pay: "Pay with QR",
  sidebar_menu_payout_batches: "Batch payouts",
  sidebar_menu_holders: "Holders",
  sidebar_menu_pockets: "Pockets",
  sidebar_menu_confirmations: "Confirmations",
  sidebar_menu_payments: "Payment requests",
  sidebar_menu_payout_rescue: "Payout rescue",
  sidebar_menu_swaps: "Swaps",
  sidebar_menu_audit: "Audit",
  sidebar_menu_accounts_tracking: "Account tracking",
  sidebar_menu_payins: "Receive money",
  sidebar_menu_payments_activity: "Activity",
  sidebar_menu_payments_notifications: "Notifications",
  sidebar_menu_crypto_swaps_group: "Crypto",
  sidebar_menu_crypto_swaps: "Buy USDT",
  sidebar_menu_crypto_sell: "Sell USDT",
  sidebar_menu_crypto_swaps_history: "History",
  sidebar_menu_payments_ledger: "Ledger",
  sidebar_menu_account_verification: "Account verification",
  sidebar_menu_cards: "Cards",
  sidebar_menu_cards_notifications: "Notifications",
  sidebar_menu_routes_countries: "Routes and countries",
  sidebar_menu_organizations: "Organizations",
  sidebar_menu_wallet_top_ups: "Wallet top-ups",
  sidebar_menu_card_wallets: "Card wallet",
  sidebar_menu_payment_rails: "Payment rails",
  sidebar_menu_payment_limits: "Amount limits",
  sidebar_menu_rate_providers: "Rate providers",
  sidebar_menu_metrics: "Metrics",
  sidebar_menu_payment_routes: "Corridors & providers",
  sidebar_menu_payment_fees: "Fees & commissions",
  sidebar_menu_payment_taxes: "Taxes",

  sidebar_menu_deposit_clabes: "Deposit CLABEs",
  sidebar_menu_deposit_cvus: "Deposit CVUs",
  sidebar_menu_quoter: "Quoter",
  sidebar_menu_quoter_coloca: "Coloca Quoter",
  sidebar_menu_news: "News",
  no_access_title: "You don't have permission",
  no_access_description:
    "You don't have permission to open this section. If you think you should, contact your account administrator.",
  no_access_back_home: "Back to start",
  no_navigation_access_title: "Your account has no access yet",
  no_navigation_access_description:
    "No access has been assigned to you yet. Contact your organization administrator so they can grant what you need.",
  sidebar_menu_users: "Users",
  sidebar_menu_clients: "Clients",
  sidebar_menu_api_keys: "API keys",
  sidebar_menu_roles: "Roles",
  sidebar_menu_policies: "Policies",
  loading_button: "Loading...",
  pagination_records: "Records {{from}} to {{to}} of {{total}}",
  pagination_empty: "No records",
  pagination_total_pages: "Total pages ({{lastPage}})",
  pagination_first_page: "First page",
  pagination_prev_page: "Previous page",
  pagination_next_page: "Next page",
  pagination_last_page: "Last page",
  modal_confirm_button: "Confirm",
  modal_cancel_button: "Cancel",
  phone_field_select_country_placeholder: "Select a country first",
  phone_field_search_country_placeholder: "Search country…",
  nav_user_account: "Account",
  nav_user_settings: "Settings",
  nav_user_logout: "Log out",
  nav_user_organization: "Organization",
  nav_user_install_app: "Install app",
  pwa_update_activated_elsewhere:
    "A new version of Coloca is running. Reload this tab when you finish what you are doing.",
  pwa_reload_action: "Reload",
  pwa_update_menu: "Update to the new version",
  pwa_install_title: "Install Coloca",
  pwa_install_body: "Keep it on your home screen and open it without looking for the link.",
  pwa_install_body_open_in_safari: "To install it, open this page in Safari.",
  pwa_install_ios_step_share: "Tap <b>Share</b>",
  pwa_install_ios_step_share_hint: "If it isn't in the bar, look under •••",
  pwa_install_ios_step_add: "Choose <b>Add to Home Screen</b>, then <b>Add</b>",
  pwa_install_action: "Install",
  pwa_install_later: "Not now",
  pwa_install_close: "Close",
  pwa_install_copy_link: "Copy link",
  pwa_install_link_copied: "Link copied. Paste it in Safari.",
  pwa_install_link_copied_short: "Copied",
  pwa_install_copy_error: "Couldn't copy the link.",
  header_notifications_title: "Notifications",
  header_notifications_empty: "No notifications yet",
  header_notifications_load_more: "Show older",
  header_notifications_mark_read_failed: "Could not mark it as read. Try again.",
  pix_key_ph_cpf: "000.000.000-00",
  pix_key_helper_cpf: "11 digits, no dots or dashes.",
  pix_key_err_cpf: "The CPF must have 11 digits.",
  pix_key_ph_cnpj: "00.000.000/0000-00",
  pix_key_helper_cnpj: "14 digits, no dots or dashes.",
  pix_key_err_cnpj: "The CNPJ must have 14 digits.",
  pix_key_ph_email: "name@domain.com",
  pix_key_helper_email: "Lowercase email, e.g. name@domain.com.",
  pix_key_err_email: "Enter a valid lowercase email.",
  pix_key_ph_phone: "(11) 98765-4321",
  pix_key_helper_phone: "Number with area code, up to 11 digits.",
  pix_key_err_phone: "The phone must have 10 or 11 digits.",
  pix_key_ph_evp: "123e4567-e89b-12d3-a456-426614174000",
  pix_key_helper_evp: "Paste the random key (UUID format).",
  pix_key_err_evp: "The key must be in UUID format.",
  route_error_title: "Something unexpected went wrong",
  route_error_description: "This screen could not be displayed. Reload the page to pick up where you were.",
  route_error_reload: "Reload the page",
  country_ARG: "Argentina",
  country_BRA: "Brazil",
  country_CHL: "Chile",
  country_COL: "Colombia",
  country_MEX: "Mexico",
  country_PER: "Peru",
  subdivision_placeholder: "Search a state or province",
  subdivision_empty: "No results",
  amount_hidden: "Hidden amount",
  security_pin_step_label: "Step {{step}} of {{total}}",
  security_pin_step_create_title: "Choose your 6-digit PIN",
  security_pin_step_create_hint: "Avoid dates, repeated digits and runs.",
  security_pin_step_confirm_title: "Type it again",
  security_pin_step_confirm_hint: "To make sure you remember it.",
  security_pin_step_password_title: "Confirm it's you",
  security_pin_step_password_hint:
    "Enter the password you sign in with, so nobody can create a PIN from your open session.",
  security_pin_password_label: "Password",
  security_pin_password_show: "Show password",
  security_pin_password_hide: "Hide password",
  security_pin_password_required: "Enter your password.",
  security_pin_show: "Show PIN",
  security_pin_hide: "Hide PIN",
  security_pin_issue_repeated: "Don't use the same digit six times.",
  security_pin_issue_sequence: "Avoid runs like 123456 or 654321.",
  security_pin_issue_pattern:
    "Avoid easy-to-guess patterns like 121212, 112233, 123321 or lines on the keypad.",
  security_pin_issue_common: "That PIN is too common. Choose another one.",
  security_pin_strength_ok: "Good PIN",
  security_pin_mismatch: "That doesn't match the PIN you chose. Type it again.",
  security_pin_next: "Continue",
  security_pin_back: "Back",
  security_pin_submit_create: "Create PIN",
  security_pin_submit_create_continue: "Create PIN and continue",
  security_pin_submit_change: "Save new PIN",
  security_pin_done_title: "Your PIN is ready",
  security_pin_done_body: "We'll ask for it on sensitive actions, like creating cards or moving money.",
  security_pin_done_email_backup: "Email backup on: if you forget your PIN, we email you a code.",
  security_pin_done_body_continue: "Now confirm the action with your new PIN.",
  security_pin_done_body_challenge: "Go back and type your new PIN to confirm.",
  security_pin_done_continue: "Continue",
  security_pin_done_close: "Done",
  security_pin_done_back_to_challenge: "Type my PIN",
  security_pin_error_password: "That password isn't right.",
  security_pin_error_generic: "We couldn't save your PIN. Try again.",
  security_pin_dialog_create_title: "Create your security PIN",
  security_pin_dialog_change_title: "Change security PIN",
  security_pin_dialog_reset_title: "Create a new PIN",
  security_pin_dialog_description: "Six digits that will confirm your sensitive actions.",
  step_up_required_title: "Protect this action",
  step_up_choice_totp_name: "Authenticator app",
  step_up_choice_totp_badge: "Recommended · Most secure",
  step_up_choice_totp_body:
    "Google Authenticator, Authy or similar gives you a new code every 30 seconds. Even someone who knows your password can't confirm anything without your phone.",
  step_up_choice_totp_time: "≈ 3 min, in Settings",
  step_up_choice_pin_name: "Security PIN",
  step_up_choice_pin_badge: "Fastest",
  step_up_choice_pin_body:
    "Six digits you choose. Create it right here and carry on with what you were doing. It's less secure than the app: it's something you know, not something you have.",
  step_up_choice_pin_time: "≈ 1 min, right here",
  step_up_choice_footnote:
    "You can start with the PIN and switch to the app any time: once it's on, it replaces the PIN.",
  step_up_choice_go_totp: "Set up the app",
  step_up_choice_create_pin: "Create PIN",
  step_up_meter_security: "Security",
  step_up_meter_speed: "Speed",
  two_factor_challenge_pin_title: "Enter your security PIN",
  two_factor_challenge_pin_description: "The 6 digits you chose to confirm sensitive actions.",
  two_factor_challenge_pin_forgot: "Forgot your PIN? Create a new one",
  two_factor_challenge_pin_locked_title: "Your PIN is locked",
  two_factor_challenge_pin_locked:
    "Too many wrong attempts. You can try again in {{time}}, or create a new PIN now with your password.",
  two_factor_challenge_pin_reset_required:
    "It was locked after too many wrong attempts. Create a new PIN with your password to continue.",
  two_factor_challenge_pin_new: "Create new PIN",
  reauth_password_incorrect_hint:
    "That password isn't right. After 5 failed attempts we lock your account for 30 minutes.",
  security_pin_error_reused: "Your new PIN must be different from the current one.",
  security_pin_issue_date:
    "It looks like a date, such as a birthday: one of the first things someone would try.",
  security_pin_issue_phone: "It's part of your phone number. Choose another one.",
  two_factor_challenge_totp_locked_title: "Verification paused",
  two_factor_challenge_totp_locked: "There were 5 wrong codes in a row. You can try again in {{time}}.",
  step_up_sessions_revoked:
    "For your security we locked your PIN and closed your sessions. Sign in and create a new PIN in Settings → Security.",
  step_up_email_offer_pin: "Don't have your PIN at hand?",
  step_up_email_offer_totp: "Don't have your phone at hand?",
  step_up_email_offer_action: "Get a code by email",
  step_up_email_sending: "Sending the code…",
  step_up_email_title: "Check your email",
  step_up_email_description_fallback:
    "We sent a 6-digit code to your email. It expires in 10 minutes and only approves this action.",
  step_up_email_code_label: "Code we sent you by email",
  step_up_email_spam_hint: "Not there? Check your spam folder or ask for another code.",
  step_up_email_resend: "Resend code",
  step_up_email_resend_in: "Resend in {{time}}",
  step_up_email_resent: "We sent you a new code. The previous one no longer works.",
  step_up_email_back_pin: "Back to my PIN",
  step_up_email_back_totp: "Back to my app",
  step_up_email_code_invalid:
    "This code no longer works: it expired, was already used or had too many attempts. Ask for a new one.",
  step_up_email_not_enabled: "The email backup is off. You can turn it on in Settings → Security.",
  step_up_email_error_generic: "We couldn't send the code. Try again in a moment.",
  step_up_choice_pin_email_note: "Includes an email backup",
  step_up_choice_totp_email_note: "Optional email backup",
  step_up_email_backup_error_requires_method:
    "Choose the authenticator app or a PIN first: the email backup is that method's plan B.",
  step_up_email_backup_error_not_available: "The email backup isn't available for your account.",
  step_up_email_backup_error_generic: "We couldn't save the change. Try again.",
  tax_transaction_cost: "Transaction cost",
};
